<script>
	import Document from  "$lib/sections/Document.svelte";

	export let data;

	let lang;
	$: lang = data.lang;

	let area;
	$: area = data.area;

	const col = "privacy policy";
</script>

<Document {data} {lang} {area} {col} settingId={"Document"} />
